import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { appConfig } from '../../config/app';
import BrandLogo from '../shared/BrandLogo';

const HeaderLoggedOutDesktop = () => {
    const history = useHistory();

    const handleFaqClick = () => {
        const faqElement = document.getElementById('faq');
        if (faqElement) {
            faqElement.scrollIntoView({ behavior: 'smooth' });
        } else {
            // Navigate to homepage and scroll to FAQ after navigation
            history.push('/');
            setTimeout(() => {
                const faqElement = document.getElementById('faq');
                if (faqElement) {
                    faqElement.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    };

    return (
        <div className="d-lg-block d-none mb-3">
            <Navbar fixed="top" collapseOnSelect expand="lg" variant="dark" className="navbar-glass">
                <Container fluid>
                    <Navbar.Brand>
                        <BrandLogo />
                    </Navbar.Brand>
                    
                    <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link onClick={handleFaqClick} style={{ cursor: 'pointer' }}>FAQ</Nav.Link>
                        </Nav>
                        
                        <Nav className="ms-auto d-flex align-items-center">
                            {/* Discord Logo */}
                            <a 
                                href={appConfig.social.discord}
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="me-3"
                                style={{ fontSize: '1.5rem', color: '#5865f2' }}
                            >
                                <i className="fab fa-discord"></i>
                            </a>
                            
                            {/* Login Link */}
                            <Link to="/login">
                                <button className="btn btn-outline-light me-2">
                                    Login
                                </button>
                            </Link>
                            
                            {/* Primary CTA */}
                            <Link to="/onboarding/platform">
                                <Button 
                                    className="btn-primary-gradient"
                                    style={{
                                        fontSize: "0.875rem", 
                                        fontWeight: "600",
                                        padding: "8px 16px",
                                        height: "34px",
                                        lineHeight: "1"
                                    }}
                                >
                                    Get Started
                                </Button>
                            </Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default HeaderLoggedOutDesktop;